import { Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { usePrompt } from '@hooks/usePrompt';
import { Save } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';
import { TeamForm } from '@components/teamCreation/CreateTeamUtils';
import FAB from '@atoms/FAB';

const SubmitGeneralTeamInfoFAB = () => {
    const {
        formState: { isDirty, isLoading, isSubmitting, errors },
    } = useFormContext<TeamForm>();

    const hasErrors = useMemo(() => {
        if (errors && Object.keys(errors).length > 0) {
            return !!errors;
        } else {
            return false;
        }
    }, [errors]);

    usePrompt(
        `You have unsaved changes which will be lost. \nAre you sure you want to leave?`,
        isDirty,
    );

    return (
        <FAB
            color="primary"
            disabled={!isDirty || isLoading || isSubmitting}
            toolTip={hasErrors ? <RenderError /> : 'Save Team Details'}
            type="submit"
        >
            <Save />
        </FAB>
    );
};

export default memo(SubmitGeneralTeamInfoFAB);

function RenderError() {
    const {
        formState: { errors },
    } = useFormContext<TeamForm>();

    return (['codeOfConduct', 'description', 'fee', 'imageUrl', 'name'] as (keyof TeamForm)[]).map(
        (key) => {
            return errors[key]?.message ? <Typography>{errors[key]?.message}</Typography> : null;
        },
    );
}
